import Overlay from './overlay';
import PropTypes from 'prop-types';
import React from 'react';

const HeroImage = ({heroOptions, region, imageUrl}) => {
  const hasHeroMessage = heroOptions.showHeroMessage && heroOptions.heroMessage;
  return (
    <div className="hero-slider">
      <div style={{backgroundImage: `url(${imageUrl})`}} className={`image ${hasHeroMessage ? 'ada-overlay' : ''}`}>
        <img src="/img/listing/transparent-16-9.png" alt="hero-office-custom"/>
      </div>
      <Overlay heroOptions={heroOptions || {}} region={region.urlPart}/>
    </div>
  );
};

HeroImage.propTypes = {
  heroOptions: PropTypes.object.isRequired,
  imageUrl: PropTypes.string.isRequired,
  region: PropTypes.object.isRequired
};

export default HeroImage;


// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/hero-image.js